import React, { useEffect, useMemo, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Hero } from './components/Hero';
import { Quiz } from './components/Quiz';
import { Analyzing } from './components/Analyzing';
import { Result } from './components/Result';
import { Footer } from './components/Footer';
import { questions } from './data/questions';
import { Answers, buildDiagnosis } from './utils/diagnosis';
import { trackEventOnce } from './utils/metaPixel';
type Stage = 'hero' | 'quiz' | 'analyzing' | 'result';
export function App() {
  const [stage, setStage] = useState<Stage>('hero');
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState<Answers>({});
  const timeoutRef = useRef<number | undefined>(undefined);
  const diagnosis = useMemo(() => buildDiagnosis(answers), [answers]);
  useEffect(() => {
    window.scrollTo({
      top: 0
    });
  }, [stage]);
  useEffect(() => {
    if (stage !== 'result') return;
    trackEventOnce('Lead', {
      content_name: 'Skin Fresh Index',
      value: diagnosis.score
    });
  }, [stage, diagnosis.score]);
  useEffect(() => () => window.clearTimeout(timeoutRef.current), []);
  const handleAnswer = (value: string) => {
    const question = questions[step];
    setAnswers(prev => ({
      ...prev,
      [question.id]: value
    }));
    timeoutRef.current = window.setTimeout(() => {
      if (step < questions.length - 1) {
        setStep(prev => prev + 1);
      } else {
        setStage('analyzing');
        timeoutRef.current = window.setTimeout(() => setStage('result'), 2200);
      }
    }, 320);
  };
  const handleBack = () => {
    if (step === 0) {
      setStage('hero');
      return;
    }
    setStep(prev => prev - 1);
  };
  const handleRestart = () => {
    setAnswers({});
    setStep(0);
    setStage('hero');
  };
  return <main className="min-h-[100svh] w-full bg-white" data-id="element-0" data-mp="nuhhyhj2w9tr">
      <AnimatePresence mode="wait" data-id="element-1" data-mp="sunby4ctm8f0">
        {stage === 'hero' && <motion.div key="hero" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-2" data-mp="sssqmoxn0eae">
            <Hero onStart={() => {
          trackEventOnce('ViewContent', {
            content_name: 'Skin Diagnosis Quiz'
          });
          setStep(0);
          setStage('quiz');
        }} data-id="element-3" data-mp="d4o0nv3yoa99" />
            <Footer data-id="element-4" data-mp="3glnzs6fvxakv" />
          </motion.div>}

        {stage === 'quiz' && <motion.div key="quiz" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-5" data-mp="3bnmjtudr9rdm">
            <Quiz step={step} answers={answers} onAnswer={handleAnswer} onBack={handleBack} data-id="element-6" data-mp="3limq0dwfgxds" />
          </motion.div>}

        {stage === 'analyzing' && <motion.div key="analyzing" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-7" data-mp="18d9gwhkbo4xg">
            <Analyzing data-id="element-8" data-mp="yh6agziftk4p" />
          </motion.div>}

        {stage === 'result' && <motion.div key="result" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-9" data-mp="13f7upnrlnphr">
            <Result diagnosis={diagnosis} onRestart={handleRestart} data-id="element-10" data-mp="1i3ku6upwbqh0" />
          </motion.div>}
      </AnimatePresence>
    </main>;
}